import React, { useState } from "react";
import { getInterstAmount, getPortfolio } from "../services/waitlist-service";
import { toast } from "react-toastify";
import CouponPaymentSchedule from "./CouponPaymentSchedule";
import { utils } from "../../core/helpers/utils";

export default function ObPfHoldingsBase(props) {
  const [Coupons, setCoupons] = useState({});
  const [realisedCouponsSum, setRealisedCouponsSum] = useState(0.0);
  const [showAssetTable, setShowAssetTable] = useState(false);
  const redirectToLiquidate = (product, productType) => {
    window.location.href = `/platform/#/biddeasy-asset/${productType}/${product}/redeem`;
  };

  const toggleAssetTable = () => {
    setShowAssetTable(!showAssetTable)
  } 

  const getCouponsAmount = (product) => {
    getPortfolio(
      product,
      { "X-product": `orobonds:${product}` }
    ).then((result) => {
      const response = utils.parsePayload(result);

      if (response && response.success) {
        if (response.data &&
          response.data.pfStats &&
          response.data.pfStats.pastCoupons &&
          response.data.pfStats.pastCoupons.length) {
          let pastCouponSum = 0.0;
          let pastCoupons = response?.data?.pfStats?.pastCoupons;
  
          pastCoupons.map((coupon) => {
            pastCouponSum += coupon?.justCouponPerMonth;
          })
          setRealisedCouponsSum(response.data.pfStats.couponPayout);
          setCoupons(response.data);
          setShowAssetTable(!showAssetTable);
        }
      } else {
        toast.error("Error: Orobonds portfolio: Something went wrong");
      }
      // setLoader(false);
    });
  };

  return (
    <>
    <div className="holding-card">
      {props.firstCard ? (
        <div className="inner-card first">
          <img src={props.img} alt={props.alt}/>
          <p className="font-weight-semi-bold ml-4">{props.title}</p>
        </div>
      ) : (
        <>
          <div className="flex-column">
            <div className="inner-card d-flex ">
              <div className="d-flex" style={{alignItems: "baseline"}}>
                <p className="text-muted title">{props.title} </p>
              </div>
              <p className="font-weight-semi-bold" 
                style={props.value === "Completed" 
                ? {color: "#24C034"} : {}}
              >
                {props.value}
              </p>
            </div>
            {props?.isRedemptionAllowed && (
              <p
                className={`liquid ${!props?.isMobile ? "text-center" : ""}`}
                onClick={() =>
                  redirectToLiquidate(props?.productName, props?.productType)
                }
              >
                Liquidate Now
              </p>
            )} 
            {props?.showMore && (
              <p
                className={`liquid ${!props?.isMobile ? "text-center" : ""}`}
                onClick={() => getCouponsAmount(props?.productm)}
              >
                Show More
              </p>
            )} 
          </div>
        </>
      )}
    </div>

    <CouponPaymentSchedule 
      showAssetTable={showAssetTable}
      toggleAssetTable={toggleAssetTable}
      realisedCouponsSum={realisedCouponsSum}
      Coupons={Coupons}
      fromMaturedTab={true}
    />
    </>
  );
}